require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./relazioni-e-conferenze-nicola-navone-architecture-et-territoire-au-tessin-epfl-enac-sar-7-marzo-2022.json") })
        }
      }, "path---relazioni-e-conferenze-nicola-navone-architecture-et-territoire-au-tessin-epfl-enac-sar-7-marzo-2022");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---relazioni-e-conferenze-nicola-navone-architecture-et-territoire-au-tessin-epfl-enac-sar-7-marzo-2022!./.cache/json/relazioni-e-conferenze-nicola-navone-architecture-et-territoire-au-tessin-epfl-enac-sar-7-marzo-2022.json
// module id = 712
// module chunks = 231608221292675